// Inhaler products — from Inhalers_List.xlsx
export const INHALER_PRODUCTS = [
  {
    "id": "pinh001",
    "name": "Salbutamol Inhaler",
    "generic": "Salbutamol Sulphate",
    "strength": "100 mcg/dose",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "Metered Dose Inhaler (MDI)",
    "desc": "Short-acting beta-2 agonist (SABA) for quick relief of asthma and COPD symptoms."
  },
  {
    "id": "pinh002",
    "name": "Beclometasone Inhaler",
    "generic": "Beclometasone Dipropionate",
    "strength": "50 mcg, 100 mcg, 200 mcg, 250 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "Inhaled corticosteroid for long-term control of asthma inflammation."
  },
  {
    "id": "pinh003",
    "name": "Budesonide Inhaler",
    "generic": "Budesonide",
    "strength": "100 mcg, 200 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "Inhaled corticosteroid for maintenance treatment of asthma."
  },
  {
    "id": "pinh004",
    "name": "Fluticasone Propionate Inhaler",
    "generic": "Fluticasone Propionate",
    "strength": "50 mcg, 125 mcg, 250 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "Inhaled corticosteroid for persistent asthma management."
  },
  {
    "id": "pinh005",
    "name": "Ipratropium Bromide Inhaler",
    "generic": "Ipratropium Bromide",
    "strength": "20 mcg/dose",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "Short-acting anticholinergic bronchodilator for COPD and asthma."
  },
  {
    "id": "pinh006",
    "name": "Salbutamol + Ipratropium Inhaler",
    "generic": "Salbutamol + Ipratropium Bromide",
    "strength": "100 mcg + 20 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "Combination SABA and anticholinergic for acute bronchospasm relief."
  },
  {
    "id": "pinh007",
    "name": "Budesonide + Formoterol Inhaler",
    "generic": "Budesonide + Formoterol Fumarate",
    "strength": "80/4.5 mcg, 160/4.5 mcg, 320/9 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI/DPI",
    "desc": "ICS/LABA combination for asthma and COPD maintenance and relief."
  },
  {
    "id": "pinh008",
    "name": "Fluticasone + Salmeterol Inhaler",
    "generic": "Fluticasone Propionate + Salmeterol",
    "strength": "125/25 mcg, 250/25 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "ICS/LABA combination for long-term asthma and COPD control."
  },
  {
    "id": "pinh009",
    "name": "Fluticasone + Formoterol Inhaler",
    "generic": "Fluticasone Propionate + Formoterol",
    "strength": "125/5 mcg, 250/10 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "ICS/LABA combination inhaler for asthma maintenance therapy."
  },
  {
    "id": "pinh010",
    "name": "Formoterol Inhaler",
    "generic": "Formoterol Fumarate",
    "strength": "12 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "DPI",
    "desc": "Long-acting beta-2 agonist (LABA) for bronchospasm prevention."
  },
  {
    "id": "pinh011",
    "name": "Tiotropium Inhalation Capsules",
    "generic": "Tiotropium Bromide",
    "strength": "18 mcg",
    "form": "Inhaler Capsule",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "DPI Capsules",
    "desc": "Long-acting anticholinergic (LAMA) capsules for COPD maintenance via DPI device."
  },
  {
    "id": "pinh012",
    "name": "Tiotropium Inhaler",
    "generic": "Tiotropium Bromide",
    "strength": "2.5 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "Soft Mist Inhaler",
    "desc": "Long-acting anticholinergic delivered via soft mist inhaler for COPD."
  },
  {
    "id": "pinh013",
    "name": "Glycopyrronium Inhalation Capsules",
    "generic": "Glycopyrronium Bromide",
    "strength": "50 mcg",
    "form": "Inhaler Capsule",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "DPI Capsules",
    "desc": "LAMA bronchodilator capsules for once-daily COPD maintenance."
  },
  {
    "id": "pinh014",
    "name": "Indacaterol Inhalation Capsules",
    "generic": "Indacaterol Maleate",
    "strength": "150 mcg, 300 mcg",
    "form": "Inhaler Capsule",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "DPI Capsules",
    "desc": "Once-daily LABA capsules for COPD maintenance bronchodilation."
  },
  {
    "id": "pinh015",
    "name": "Indacaterol + Glycopyrronium",
    "generic": "Indacaterol + Glycopyrronium Bromide",
    "strength": "110/50 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "DPI",
    "desc": "LABA/LAMA combination for COPD maintenance therapy."
  },
  {
    "id": "pinh016",
    "name": "Umeclidinium Inhaler",
    "generic": "Umeclidinium Bromide",
    "strength": "62.5 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "DPI",
    "desc": "Long-acting anticholinergic for once-daily COPD maintenance."
  },
  {
    "id": "pinh017",
    "name": "Umeclidinium + Vilanterol",
    "generic": "Umeclidinium Bromide + Vilanterol",
    "strength": "62.5/25 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "DPI",
    "desc": "LAMA/LABA combination inhaler for COPD maintenance."
  },
  {
    "id": "pinh018",
    "name": "Tiotropium + Olodaterol",
    "generic": "Tiotropium + Olodaterol",
    "strength": "2.5/2.5 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "Soft Mist Inhaler",
    "desc": "LAMA/LABA combination via soft mist inhaler for COPD."
  },
  {
    "id": "pinh019",
    "name": "Fluticasone Furoate + Vilanterol",
    "generic": "Fluticasone Furoate + Vilanterol",
    "strength": "100/25 mcg, 200/25 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "DPI",
    "desc": "Once-daily ICS/LABA combination for asthma and COPD."
  },
  {
    "id": "pinh020",
    "name": "Ciclesonide Inhaler",
    "generic": "Ciclesonide",
    "strength": "80 mcg, 160 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "Inhaled corticosteroid pro-drug activated in the lungs for asthma control."
  },
  {
    "id": "pinh021",
    "name": "Levosalbutamol Inhaler",
    "generic": "Levosalbutamol",
    "strength": "50 mcg",
    "form": "Inhaler",
    "category": "inhalers",
    "segment": "Respiratory",
    "pack": "MDI",
    "desc": "R-enantiomer SABA bronchodilator for asthma and COPD relief."
  }
];
